export enum PermissionMassiveOption {
  MASSIVE_COMMON_LOGIN = 'masivos',
}
